import AppointmentDetailPage from "@/modules/vendor/pages/VendorAppontmentDetailPage.vue";
import AppointmentCancelRequestedDetailPage from "@/modules/vendor/pages/AppointmentCancelRequestedDetailPage.vue";
import InquiryDetailPage from "@/modules/vendor/pages/InquiryDetailPage.vue";
import VendorMessageDetailPage from "@/modules/vendor/pages/VendorMessageDetailPage.vue";
import ProfileSetupPage from "@/modules/vendor/pages/ProfileSetupPage.vue";
import CustomersPage from "@/modules/vendor/pages/CustomersPage.vue";
import InquiryPage from "@/modules/vendor/pages/InquiryPage.vue";
import PosPage from "@/modules/vendor/pages/PosPage.vue";
import QuotationPage from "@/modules/vendor/pages/QuotationPage.vue";
import QuotationDetailPage from "@/modules/vendor/pages/QuotationDetailPage.vue";
import QuotationFormPage from "@/modules/vendor/pages/QuotationFormPage.vue";
import QuotationTemplateDetailPage from "@/modules/vendor/pages/QuotationTemplateDetailPage.vue";
import StaffFormPage from "@/modules/vendor/pages/StaffFormPage.vue";
const VendorSchedulePage = () => import("@/modules/vendor/pages/VendorSchedulePage.vue");
const VendorScheduleSuccessPage = () =>
  import("@/modules/vendor/pages/VendorScheduleSuccessPage.vue");
import type { RouteRecordRaw } from "vue-router";
import CompanyApplyPage from "@/modules/vendor/pages/CompanyApplyPage.vue";
import ApplyCompanyMembershipForm from "@/modules/vendor/pages/ApplyCompanyMembershipForm.vue";
import CompanyDetailPage from "@/modules/vendor/pages/CompanyDetailPage.vue";
import ApplyForCompany from "@/modules/vendor/pages/ApplyForCompany.vue";
const JoinAsVendorHomePage = () => import("@/modules/vendor/pages/JoinAsVendorHome.vue");
const JoinAsCompanyHomePage = () => import("@/modules/vendor/pages/JoinAsCompanyHome.vue");

const VendorLayout = () => import("@/app/layouts/VendorLayout.vue");
const SharedLayout = () => import("@/app/layouts/SharedLayout.vue");
const VendorMessageLayout = () => import("@/app/layouts/VendorMessageLayout.vue");
const DashboardPage = () => import("@/modules/vendor/pages/VendorDashboardPage.vue");
const MessagesPage = () => import("@/modules/vendor/pages/VendorMessagePage.vue");
const SettingsPage = () => import("@/shared/pages/SettingsPage.vue");
const GeneralSettingsPage = () => import("@/modules/vendor/pages/GeneralSettingsPage.vue");
const PersonalInfoPage = () => import("@/shared/pages/PersonalInfoPage.vue");
const SavedAddressesPage = () => import("@/shared/pages/SavedAddressesPage.vue");
const SavedAddressEditPage = () => import("@/shared/pages/SavedAddressEditPage.vue");
const PaymentMethodsPage = () => import("@/shared/pages/PaymentMethodsPage.vue");
const HelpCenterPage = () => import("@/shared/pages/HelpCenterPage.vue");
const ContactSupportPage = () => import("@/shared/pages/ContactSupportPage.vue");
const TermsPrivacyPage = () => import("@/shared/pages/TermsPrivacyPage.vue");
const DeleteAccountPage = () => import("@/shared/pages/DeleteAccountPage.vue");

const ServicePage = () => import("@/modules/vendor/pages/ServicePage.vue");
const ServiceFormPage = () => import("@/modules/vendor/pages/ServiceFormPage.vue");
const ServicePackagePage = () => import("@/modules/vendor/pages/ServicePackagePage.vue");
const ServicePackageFormPage = () => import("@/modules/vendor/pages/ServicePackageFormPage.vue");
const ServicePackageDetailPage = () => import("@/modules/vendor/pages/ServicePackageDetailPage.vue");
const CouponPage = () => import("@/modules/vendor/pages/CouponPage.vue");
const CouponFormPage = () => import("@/modules/vendor/pages/CouponFormPage.vue");
const PaymentSetupPage = () => import("@/modules/vendor/pages/PaymentSetupPage.vue");
const PaymentSetupFormPage = () => import("@/modules/vendor/pages/PaymentSetupFormPage.vue");
const TaxPage = () => import("@/modules/vendor/pages/TaxPage.vue");
const TaxFormPage = () => import("@/modules/vendor/pages/TaxFormPage.vue");
const ServiceDetailPage = () => import("@/modules/vendor/pages/ServiceDetailPage.vue");
const WorkingSchedulePage = () => import("@/modules/vendor/pages/WorkingSchedulePage.vue");
const QuestionPage = () => import("@/modules/vendor/pages/QuestionPage.vue");
const QuestionFormPage = () => import("@/modules/vendor/pages/QuestionForm.vue");

// added vendor feature pages
const AppointmentsPage = () => import("@/modules/vendor/pages/VendorAppontmentPage.vue");
const AppointmentCancelRequestedPage = () =>
  import("@/modules/vendor/pages/AppointmentCancelRequestedPage.vue");
const LeadsPage = () => import("@/modules/vendor/pages/LeadsPage.vue");
const SubscriptionPage = () => import("@/modules/vendor/pages/SubscriptionPage.vue");
const SubscriptionDetailPage = () => import("@/modules/vendor/pages/SubscriptionDetailPage.vue");
const StaffsPage = () => import("@/modules/vendor/pages/StaffsPage.vue");
const StaffDetailPage = () => import("@/modules/vendor/pages/StaffDetailPage.vue");
const CustomerDetailPage = () => import("@/modules/vendor/pages/CustomerDetailPage.vue");

const SurveyPage = () => import("@/modules/vendor/pages/SurveyPage.vue");
const SurveyDetailPage = () => import("@/modules/vendor/pages/SurveyDetailPage.vue");

export const vendorRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    component: SharedLayout,
    meta: { requiresAuth: false, contextType: "vendor" },
    children: [
      {
        path: "join-as-vendor-home",
        name: "join-as-vendor.home",
        component: JoinAsVendorHomePage,
        meta: { title: "Join as Vendor", requiresAuth: false },
      },
      {
        path: "join-as-company-home",
        name: "join-as-company.home",
        component: JoinAsCompanyHomePage,
        meta: { title: "Join as Company", requiresAuth: false },
      },
      {
        path: "schedule-demo/success",
        name: "vendor.schedule.success",
        component: VendorScheduleSuccessPage,
        meta: { title: "Back", requiresAuth: true },
      },
    ],
  },
  {
    path: "/vendor",
    component: VendorLayout,
    meta: { requiresAuth: true, contextType: "vendor" },
    children: [
      {
        path: "dashboard",
        name: "vendor.dashboard",
        component: DashboardPage,
        meta: { title: "Dashboard" },
      },
      {
        path: "profile-setup",
        name: "vendor.profile-setup",
        component: ProfileSetupPage,
        meta: { title: "Profile Setup", requiresAuth: true },
      },
      {
        path: "schedule-demo",
        name: "vendor.schedule.demo",
        component: VendorSchedulePage,
        meta: { title: "Schedule a Demo", requiresAuth: true },
      },
    ],
  },
  {
    path: "/vendor",
    component: SharedLayout,
    meta: { requiresAuth: true, contextType: "vendor" },
    children: [
      { path: "", redirect: { name: "vendor.dashboard" } },
      {
        path: "teams/:id",
        name: "vendor.team.detail",
        component: StaffDetailPage,
        props: true,
        meta: { title: "Team Detail" },
      },
      {
        path: "appointments",
        name: "vendor.appointments",
        component: AppointmentsPage,
        meta: { title: "Appointments" },
      },
      {
        path: "appointments/cancel-requested",
        name: "vendor.appointments.cancel-requested",
        component: AppointmentCancelRequestedPage,
        meta: { title: "Back" },
      },
      {
        path: "appointments/cancel-requested/:id",
        name: "vendor.appointment.cancel-request.detail",
        component: AppointmentCancelRequestedDetailPage,
        props: true,
        meta: { title: "Request Detail" },
      },
      {
        path: "appointments/:id",
        name: "vendor.appointment.detail",
        component: AppointmentDetailPage,
        props: true,
        meta: { title: "Appointment Detail" },
      },
      {
        path: "customers",
        name: "vendor.customers",
        component: CustomersPage,
        meta: { title: "Customers" },
      },
      {
        path: "customers/:id",
        name: "vendor.customers.detail",
        component: CustomerDetailPage,
        props: true,
        meta: { title: "Customer Detail" },
      },
      {
        path: "leads",
        name: "vendor.leads",
        component: LeadsPage,
        meta: { title: "Leads" },
      },
      {
        path: "subscriptions",
        name: "vendor.subscriptions",
        component: SubscriptionPage,
        meta: { title: "Subscriptions" },
      },
      {
        path: "subscriptions/:id",
        name: "vendor.subscriptions.detail",
        component: SubscriptionDetailPage,
        props: true,
        meta: { title: "Subscription Detail" },
      },
      {
        path: "staffs",
        name: "vendor.staffs",
        component: StaffsPage,
        meta: { title: "Back" },
      },
      {
        path: "staff-form",
        name: "vendor.staffs.form",
        component: StaffFormPage,
        meta: { title: "Staff Form" },
      },
      {
        path: "messages",
        name: "vendor.messages",
        component: MessagesPage,
        meta: { title: "Messages" },
      },
      {
        path: "inquiries",
        name: "vendor.inquiries",
        component: InquiryPage,
        meta: { title: "Inquiries" },
      },
      {
        path: "inquiries/:id",
        name: "vendor.inquiry.detail",
        component: InquiryDetailPage,
        props: true,
        meta: { title: "Inquiry Detail" },
      },
      {
        path: "quotations",
        name: "vendor.quotations",
        component: QuotationPage,
        meta: { title: "Quotations" },
      },
       {
        path: 'quotations/:id',
        name: 'vendor.quotations.detail',
        component: QuotationDetailPage,
        meta: { title: 'Quotation Details' }
      },

      {
        path: "quotation-templates/form",
        name: "vendor.quotation.form",
        component: QuotationFormPage,
        props: true,
        meta: { title: "Create Quotation" },
      },
      {
        path: "quotation-templates",
        name: "vendor.quotation.templates",
        component: QuotationTemplateDetailPage,
        meta: { title: "Quotation Templates" },
      },
      {
        path: "quotation-templates/:id",
        name: "vendor.quotation.template.detail",
        component: QuotationTemplateDetailPage,
        props: true,
        meta: { title: "Back" },
      },
      {
        path: "settings",
        name: "vendor.settings",
        component: SettingsPage,
        meta: { title: "Setting Page" },
      },
      {
        path: "general-settings",
        name: "vendor.general-settings.page",
        component: GeneralSettingsPage,
        meta: { title: "General Settings" },
      },
      {
        path: "services",
        name: "vendor.service.page",
        component: ServicePage,
        meta: { title: "Services" },
      },
      {
        path: "services/form",
        name: "vendor.service.form",
        component: ServiceFormPage,
        meta: { title: "Add Service" },
      },
      {
        path: "services/:id",
        name: "vendor.service.detail",
        component: ServiceDetailPage,
        props: true,
        meta: { title: "Service Detail" },
      },
      {
        path: "service-packages",
        name: "vendor.service.package",
        component: ServicePackagePage,
        meta: { title: "Back" },
      },
      {
        path: "service-packages/form",
        name: "vendor.service.package.form",
        component: ServicePackageFormPage,
        meta: { title: "Back" },
      },
      {
        path: "service-packages/:id",
        name: "vendor.service.package.detail",
        component: ServicePackageDetailPage,
        props: true,
        meta: { title: "Back" },
      },
      {
        path: "coupons",
        name: "vendor.coupons",
        component: CouponPage,
        meta: { title: "Coupons" },
      },
      {
        path: "coupons/form/:id?",
        name: "vendor.coupons.form",
        component: CouponFormPage,
        props: true,
        meta: { title: "Coupon Form" },
      },
      {
        path: "payment-setup",
        name: "vendor.payment-setup.page",
        component: PaymentSetupPage,
        meta: { title: "Payment Setup" },
      },
      {
        path: "payment-setup/:id",
        name: "vendor.payment-setup.form",
        component: PaymentSetupFormPage,
        props: true,
        meta: { title: "Stripe Credential Form" },
      },
      {
        path: "tax",
        name: "vendor.tax.page",
        component: TaxPage,
        meta: { title: "Tax setup" },
      },
      {
        path: "tax/form",
        name: "vendor.tax.form",
        component: TaxFormPage,
        meta: { title: "Tax setup" },
      },
      {
        path: "working-schedule",
        name: "vendor.working-schedule.page",
        component: WorkingSchedulePage,
        meta: { title: "Working Schedule" },
      },
      {
        path: "inquiry-questions",
        name: "vendor.questions.page",
        component: QuestionPage,
        meta: { title: "Back" },
      },
      {
        path: "inquiry-questions/form/:id?",
        name: "vendor.questions.form",
        component: QuestionFormPage,
        props: true,
        meta: { title: "Inquiry Question Form" },
      },
      {
        path: "profile",
        name: "vendor.profile",
        component: PersonalInfoPage,
        meta: { title: "Personal Information" },
      },
      {
        path: "saved-addresses",
        name: "vendor.saved-addresses",
        component: SavedAddressesPage,
        meta: { title: "Saved Addresses" },
      },
      {
        path: "saved-addresses/:id",
        name: "vendor.saved-addresses.edit",
        component: SavedAddressEditPage,
        meta: { title: "Edit Address" },
      },
      {
        path: "payment-methods",
        name: "vendor.payment-methods",
        component: PaymentMethodsPage,
        meta: { title: "Payment Methods" },
      },
      {
        path: "help-center",
        name: "vendor.help-center",
        component: HelpCenterPage,
        meta: { title: "Help Center" },
      },
      {
        path: "contact-support",
        name: "vendor.contact-support",
        component: ContactSupportPage,
        meta: { title: "Contact Support" },
      },
      {
        path: "terms-privacy",
        name: "vendor.terms-privacy",
        component: TermsPrivacyPage,
        meta: { title: "Terms & Privacy" },
      },
      {
        path: "delete-account",
        name: "vendor.delete-account",
        component: DeleteAccountPage,
        meta: { title: "Delete Account" },
      },
      {
        path: "surveys",
        name: "vendor.surveys",
        component: SurveyPage,
        meta: { title: "Surveys" },
      },
      {
        path: "surveys/:id",
        name: "vendor.surveys.detail",
        component: SurveyDetailPage,
        props: true,
        meta: { title: "Survey Detail" },
      },

      {
        path: "pos",
        name: "vendor.pos",
        component: PosPage,
        meta: { title: "POS" },
      },
      {
        path: "company-list",
        name: "vendor.company-list",
        component: CompanyApplyPage,
        meta: { title: "Back" },
      },
      {
        path: "company/:id",
        name: "vendor.company.detail",
        component: CompanyDetailPage,
        props: true,
        meta: { title: "Back" },
      },
      {
        path: "company/:companyId/apply-membership",
        name: "vendor.apply-company-memberships",
        component: ApplyCompanyMembershipForm,
        meta: { title: "Back" },
      },
      {
        path: "apply-for-company/:id",
        name: "vendor.apply-for-company",
        component: ApplyForCompany,
        meta: { title: "Back" },
      },
    ],
  },
  {
    path: "/vendor",
    component: VendorMessageLayout,
    meta: { requiresAuth: true, contextType: "vendor" },
    children: [
      {
        path: "messages/:id",
        name: "vendor.messages.detail",
        component: VendorMessageDetailPage,
        meta: { title: "Back" },
      },
    ],
  },
];
